import React, { useState } from "react";
import { MdSearch, MdNotifications, MdClose } from "react-icons/md";
import "./GameHeader.css";

const GameHeader = ({ searchTerm, setSearchTerm }) => {
  const [showSearch, setShowSearch] = useState(false);

  return (
    <div className="game-header">
      {/* FIRST ROW */}
      <div className="header-top">
        {/* DESKTOP SEARCH */}
        <div className="search-desktops">
          <MdSearch className="icon" />
          <input
            type="text"
            placeholder="Search for anything"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* MOBILE SEARCH ICON */}
        <button className="search-mobile-btn" onClick={() => setShowSearch(true)}>
          <MdSearch className="icon-large" />
        </button>

        {/* NOTIFICATION */}
        <div className="notification">
          <MdNotifications className="icon-large" />
          {/* <span className="notification-dot"></span> */}
        </div>
      </div>

      {/* MOBILE SEARCH OVERLAY */}
      {showSearch && (
        <div className="mobile-search">
          <div className="mobile-search-box">
            <MdSearch className="icon" />
            <input
              autoFocus
              type="text"
              placeholder="Search for anything"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button onClick={() => setShowSearch(false)}>
              <MdClose className="icon-large" />
            </button>
          </div>
        </div>
      )}

      {/* SECOND ROW */}
      <div className="header-title">
        <h1>Game Play Management</h1>
      </div>
    </div>
  );
};

export default GameHeader;
